<div class="square-main p-4 pt-2"
    [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">

  <div *ngIf="type === 'payment'" class="row">
    <div  class="col-6">
      <p class="title-reumen font-poppins">RESUMEN DE TRANSACCION</p>
      <p class="total-resumen font-poppins">TARIFA NETA: {{currencyPayment}} {{(totalPaymentPrice > 0 ? totalPaymentPrice : totalPrice) | number: '1.2-2'}}
      </p>
      <!-- Fee bancario registrado por el backend en esta transacción -->
      <ng-container *ngFor="let bankFee of getCurrentTransactionBankFees()">
        <p class="resumen-fee font-poppins">
          FEE BANCARIO<span *ngIf="bankFee.percentage !== null"> ({{bankFee.percentage | number: '1.0-2'}}%)</span>:
          {{bankFee.currency}} {{bankFee.fee | number: '1.2-2'}}
        </p>
        <p class="total-resumen font-poppins">TOTAL TRANSACCIÓN: {{bankFee.currency}} {{bankFee.total | number: '1.2-2'}}</p>
      </ng-container>

      <!-- icons -->
      <div class="d-flex flex-row justify-content-start align-items-center mt-5">
        <div class="d-flex ml-2">

          <div class="items-select d-flex align-items-center mr-2" *ngIf="verifyCategory('HOTELS')">
            <i class="icons-hotel"></i>
            <span *ngIf="verifyQuantityCategory('HOTELS') > 0">{{verifyQuantityCategory('HOTELS')}}</span>
          </div>

          <div class="items-select d-flex align-items-center mr-2" *ngIf="verifyCategory('TOURS')">
            <i class="icons-adventure"></i>
            <span *ngIf="verifyQuantityCategory('TOURS') > 0">{{verifyQuantityCategory('TOURS')}}</span>
          </div>

          <div class="items-select d-flex align-items-center mr-2" *ngIf="verifyCategory('TICKETS')">
            <i class="icons-adventure"></i>
            <span *ngIf="verifyQuantityCategory('TICKETS') > 0">{{verifyQuantityCategory('TICKETS')}}</span>
          </div>

          <div class="items-select d-flex align-items-center mr-2" *ngIf="verifyCategory('TRANSPORTS')">
            <i class="icons-transporte"></i>
            <span *ngIf="verifyQuantityCategory('TRANSPORTS') > 0">{{verifyQuantityCategory('TRANSPORTS')}}</span>
          </div>

          <div class="items-select d-flex align-items-center mr-2" *ngIf="verifyCategory('RENT-A-CAR')">
            <i class="icons-car"></i>
            <span *ngIf="verifyQuantityCategory('RENT-A-CAR') > 0">{{verifyQuantityCategory('RENT-A-CAR')}}</span>
          </div>

          <div class="items-select mr-2" *ngIf="verifyCategory('PTHEMES')">
            <i class="icon-small icon-pthemes iconstart text-center pl-1 ml-3" style="font-size: 25px;"></i>
            <span *ngIf="verifyQuantityCategory('PTHEMES') > 0">{{verifyQuantityCategory('PTHEMES')}}</span>
          </div>

          <div class="items-select mr-2" *ngIf="verifyCategory('INSURANCE')">
            <i class="icon-small icon-seguro iconstart text-center pl-1 ml-3" style="font-size: 25px;"></i>
            <span *ngIf="verifyQuantityCategory('INSURANCE') > 0">{{verifyQuantityCategory('INSURANCE')}}</span>
          </div>

          <div class="items-select mr-2" *ngIf="verifyCategory('CRUISES')">
            <i class="icon-small icon-crucero iconstart text-center pl-1 ml-3" style="font-size: 25px;"></i>
            <span *ngIf="verifyQuantityCategory('CRUISES') > 0">{{verifyQuantityCategory('CRUISES')}}</span>
          </div>

          <div class="items-select mr-2" *ngIf="verifyCategory('DISNEY')">
            <i class="icon-small icon-disney iconstart text-center pl-1 ml-3" style="font-size: 25px;"></i>
            <span *ngIf="verifyQuantityCategory('DISNEY') > 0">{{verifyQuantityCategory('DISNEY')}}</span>
          </div>

        </div>
        <!-- <div class="d-flex justify-content-center align-items-center circle-icon mr-2" *ngFor="let item of items">
          <i
            [ngClass]="{'icons-hotels': (item.categoryName=='HOTELS' || item.categoryName=='PARKS'),'icons-transports': item.categoryName=='TRANSPORTS','icons-cars': item.categoryName=='RENT-A-CAR','icons-adventures': item.categoryName=='TOURS'}"></i>
        </div> -->
      </div>
    </div>

    <div class="col-6 pl-5" style="border-left: solid white 1px;">

      <div class="row">

        <div class="col-12">
          <p class="title-resumen font-poppins">Detalle pago file</p>
        </div>

        <div class="d-flex flex-column pl-2 pr-0" style="width: 100%;">

          <div class="d-flex flex-row justify-content-between align-items-center mt-2" *ngIf="amountBLickoinsItineraryPay > 0">
            <div class="d-flex flex-row align-items-center">
              <div class="d-flex mr-2">
                <i class="icons-points-white"></i>
              </div>
              <p class="font-poppins detalle-items">PAGO POR CRÉDITO BLICKOINS</p>
            </div>
            <div class="d-flex flex-column mr-2">
              <p class="font-poppins valor-items" *ngIf="amountBLickoinsItineraryPayUSD > 0">
              USD {{ amountBLickoinsItineraryPayUSD | number: '1.2-2' }}
              </p>
              <p class="font-poppins valor-items" *ngIf="amountBLickoinsItineraryPayAgency > 0">
              {{currencyAgency?.code}} {{ amountBLickoinsItineraryPayAgency | number: '1.2-2' }}
              </p>
              <p class="font-poppins valor-items-fee" *ngFor="let bankFee of getMethodBankFees(1)">
                Neto {{bankFee.currency}} {{bankFee.net | number: '1.2-2'}} + Fee bancario<span *ngIf="bankFee.percentage !== null"> ({{bankFee.percentage | number: '1.0-2'}}%)</span> {{bankFee.currency}} {{bankFee.fee | number: '1.2-2'}}
              </p>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between align-items-center mt-2" *ngIf="amountCardItineraryPay > 0">
            <div class="d-flex flex-row align-items-center">
              <div class="d-flex mr-2">
                <i class="icons-credit-car-white"></i>
              </div>
              <p class="font-poppins detalle-items">PAGO POR TARJETA</p>
            </div>
            <div class="d-flex flex-column align-items-end mr-2">
              <div class="d-flex">
                <p class="font-poppins valor-items">USD {{amountCardItineraryPay | number:'1.2-2'}}
                </p>
                <p class="font-poppins valor-items" style="font-size: 10px;">(FEE USD {{this.itinerary.totalFee | number:'1.2-2'}})
                </p>
              </div>
              <p class="font-poppins valor-items-fee" *ngFor="let bankFee of getMethodBankFees(2)">
                Neto {{bankFee.currency}} {{bankFee.net | number: '1.2-2'}} + Fee bancario<span *ngIf="bankFee.percentage !== null"> ({{bankFee.percentage | number: '1.0-2'}}%)</span> {{bankFee.currency}} {{bankFee.fee | number: '1.2-2'}}
              </p>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between align-items-center mt-2" *ngIf="amountDepositItineraryPay > 0">
            <div class="d-flex flex-row align-items-center">
              <div class="d-flex mr-2">
                <i class="icons-profile-white"></i>
              </div>
              <p class="font-poppins detalle-items">PAGO POR DEPOSITO EN GARANTÍA</p>
            </div>
            <div class="d-flex flex-column mr-2">
              <p class="font-poppins valor-items" *ngIf="amountDepositItineraryPayUSD > 0">
              USD {{ amountDepositItineraryPayUSD | number: '1.2-2' }}
              </p>
              <p class="font-poppins valor-items" *ngIf="amountDepositItineraryPayAgency > 0">
              {{currencyAgency?.code}} {{ amountDepositItineraryPayAgency | number: '1.2-2' }}
              </p>
              <p class="font-poppins valor-items-fee" *ngFor="let bankFee of getMethodBankFees(3)">
                Neto {{bankFee.currency}} {{bankFee.net | number: '1.2-2'}} + Fee bancario<span *ngIf="bankFee.percentage !== null"> ({{bankFee.percentage | number: '1.0-2'}}%)</span> {{bankFee.currency}} {{bankFee.fee | number: '1.2-2'}}
              </p>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-between align-items-center mt-2" *ngIf="amountTransferItineraryPay > 0">
            <div class="d-flex flex-row align-items-center">
              <div class="d-flex mr-2">
                <i class="icons-transfer-white"></i>
              </div>
              <p class="font-poppins detalle-items">PAGO POR TRANSFERENCIA</p>
            </div>
            <div class="d-flex flex-column mr-2">
              <p class="font-poppins valor-items" *ngIf="amountTransferItineraryPayUSD > 0">
              USD {{ amountTransferItineraryPayUSD | number: '1.2-2' }}
              </p>
               <p class="font-poppins valor-items" *ngIf="amountTransferItineraryPayAgency > 0">
              {{currencyAgency?.code}} {{ amountTransferItineraryPayAgency | number: '1.2-2' }}
              </p>
              <p class="font-poppins valor-items-fee" *ngFor="let bankFee of getMethodBankFees(4)">
                Neto {{bankFee.currency}} {{bankFee.net | number: '1.2-2'}} + Fee bancario<span *ngIf="bankFee.percentage !== null"> ({{bankFee.percentage | number: '1.0-2'}}%)</span> {{bankFee.currency}} {{bankFee.fee | number: '1.2-2'}}
              </p>
            </div>
          </div>
          <!-- <div class="d-flex flex-row align-items-center mt-2" *ngIf="verifyAmount(5)">
            <div class="d-flex flex-row align-items-center" style="width: 230px;">
              <div class="d-flex mr-2">
                <i class="icons-credits-white"></i>
              </div>
              <p class="font-poppins detalle-items">PAGO POR CREDITOS</p>
            </div>
            <div class="d-flex">
              <p class="font-poppins valor-items">
                ${{verifyAmount(5) | number:'1.2-2'}}</p>
            </div>
          </div> -->

          <div class="d-flex">
            <p style="font-family: 'Poppins', sans-serif;font-size: 11px; font-weight: 500; padding-right: 2rem; padding-left: .4rem;margin-top: .7em;">Documento recibido. En breve administración estará validando la documentación.</p>
          </div>
        </div>
      </div>

    </div>
  </div>


  <div *ngIf="type === 'request-billed'"  class="row">
    <div class="col-6">
      <p class="title-reumen font-poppins">RESUMEN DE SOLICITUD DE FACTURACIÓN</p>
      <p class="total-resumen font-poppins">TARIFA NETA: {{currencyPayment}} {{totalPrice | number:'1.2-2'}}</p>
    </div>
    <div class="col-6 pl-5" style="border-left: solid white 1px;">

        <div class="row">
          <!-- <div class="col-12">
            <p class="title-resumen font-poppins">Detalle solicitud</p>
          </div> -->
          <div class="d-flex flex-column pl-2 pr-0">
            <div class="d-flex">
              <p style="font-family: 'Poppins', sans-serif;font-size: 11px; font-weight: 500; padding-right: 2rem; padding-left: .4rem;margin-top: .7em;">
                Solicitud recibida. Pronto su solicitud será procesada, luego recibira un email de confirmación y por ultimo podrá descargar la factura solicitada</p>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>

<div class="row mt-3">

  <div class="col-12  d-flex justify-content-end">
    <!-- <button class="btn font-poppins btn-yellow mr-2" type="button">DESCARGAR
      OPERACIÓN
    </button> -->
    <button class="btn font-poppins btn-red mr-2" type="button" (click)="allVouchersReservationPdf()" *ngIf="downloadAllVoucher">TODOS LOS VOUCHERS</button>
    <!-- <button class="btn font-poppins btn-red" type="button">TODAS FACTURAS</button> -->
  </div>
</div>

<p *ngIf="type === 'request-billed'"> En desarrollo vista y descarga de factura </p>

<div class="d-flex flex-row mt-3 card" *ngFor="let item of items; index as i">
  <div class="d-flex flex-column justify-content-center align-items-center box-check"
        [ngStyle]="{'background-color':getClientsSettingAppBooking?.clients_setting_global?.color_main_2}">
    <span class="mb-0">
      <label class="custom-radio-checkbox mb-0">
        <input class="custom-radio-checkbox__input" type="checkbox" [name]="i" (change)="handleItem(item)" checked>
        <span class="custom-radio-checkbox__show custom-radio-checkbox__show--radio"></span>
      </label>
    </span>
  </div>
  <div class="d-flex flex-row justify-content-start align-items-center p-3 description-item">
    <i class="mr-3"
      [ngClass]="{'icons-hotel': (item.categoryName=='HOTELS' || item.categoryName=='PARKS'),'icons-transporte': item.categoryName=='TRANSPORTS','icons-car': item.categoryName=='RENT-A-CAR','icons-adventure': item.categoryName=='TOURS'}"></i>
    <div class="d-flex flex-column">
      <p class="categoria-items font-poppins">{{ item.categoryName }}</p>
      <p class="title-items font-poppins m-0">{{stingUpperCase(item.title)}}</p>
    </div>
    <!-- <p class="font-weight-bold font-poppins m-0" style="font-size: 13px;">{{item.destination.iata_code}} - US</p> -->
  </div>

  <div class="d-flex flex-column justify-content-center align-items-center p-3 ml-auto"
  [ngStyle]="{'margin-right': type === 'payment' ? '0' : '0'}" >
    <div class="d-flex" style="gap: .25em;">
       <p *ngIf="type === 'request-billed'" class="importe-items font-poppins" style="font-weight: 500;">SOLICITADO</p>
      <p *ngIf="type === 'request-billed'" class="importe-items font-poppins" style="font-weight: 600;">
        <!-- {{currencyItinerary}} {{item.netPriceBooking | number:'1.2-2'}} -->

        <span *ngIf="type === 'request-billed'">
          {{currencyAgency?.code}} {{ item.converted_amounts ? item.converted_amounts.netPriceBooking : item.netPriceBooking }}
        </span>
      </p>
    </div>
    <div class="d-flex" style="gap: .25em;" *ngIf="type === 'payment' && getItemPaidAmount(item.id) as paidAmount">
      <ng-container *ngIf="paidAmount.usd > 0 || paidAmount.agency > 0">
        <p class="importe-items font-poppins" style="font-weight: 500;">PAGADO</p>
        <p class="importe-items font-poppins" style="font-weight: 600;">
          <span *ngIf="paidAmount.usd > 0">USD {{ paidAmount.usd | number:'1.2-2' }}</span>
          <span *ngIf="paidAmount.usd > 0 && paidAmount.agency > 0"> / </span>
          <span *ngIf="paidAmount.agency > 0">{{ currencyAgency?.code }} {{ paidAmount.agency | number:'1.2-2' }}</span>
        </p>
      </ng-container>
    </div>
    <div *ngIf="type === 'payment'" class="d-flex flex-column justify-content-center align-items-center pt-2 ml-auto" style="margin-right:-18px;">
      <span class="indicadores ind-pap px-3">
        Pendiente aprobación de pago
      </span>
    </div>
  </div>
  <div *ngIf="type === 'payment'" class="d-flex flex-row justify-content-center align-items-center p-3">
   <!--- <i class="icons-pay-pdf mr-3"></i> -->
   <i class="icons-vouchers" (click)="vouchersReservationPdf(item.id)"></i>
  </div>

